import { render, staticRenderFns } from "./AdminDeleteUser.vue?vue&type=template&id=8766bb0e"
import script from "./AdminDeleteUser.vue?vue&type=script&lang=js"
export * from "./AdminDeleteUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports